import { EVENT_TYPE } from "@/const.js";
import { type Events, hooks } from "@/store.js";
import { memo, Suspense, useMemo, useState } from "react";
import isEqual from "react-fast-compare";

import Type from "./Type.jsx";
import ImageLightBox from "@/components/ImageLightBox/index.jsx";
import { useModal } from "@ebay/nice-modal-react";
import { getTimeText } from "@/utils/event.js";

// const config = EVENT_TYPE.find((i) => i.label === '自定义活动');

interface IProps {
	id: string;
	onClick?: (payload: { id: string }) => void;
}

const Custom = memo(({ id, onClick, record }: IProps & { record: Events }) => {
	const dataEntity = record.get("custom");
	const data = dataEntity?.getAll();
	hooks.useWatch(
		record,
		// { deep: true }
	);
	hooks.useWatch(dataEntity, { deep: true });

	const cover = record.get("cover");
	const type = record.get("type");
	const images = record.get("images");
	const startTime = record.get("startTime");
	const endTime = record.get("endTime");
	const coverUrl = cover ? `https://trip-qiniu.pmlife.top/${cover}` : "";

	const config = useMemo(
		() => EVENT_TYPE.find((i) => i.value === type),
		[type],
	);

	const imagesList = useMemo(() => {
		return images.map((i) =>
			i.startsWith("http") ? i : `https://trip-qiniu.pmlife.top/${i}`,
		);
	}, [images]);

	const imageLightBox = useModal(ImageLightBox);
	const time = useMemo(
		() => getTimeText({ startTime, endTime }),
		[startTime, endTime],
	);

	const money = record.get("money");
	const icon = record.get("icon");
	const [isExpand] = useState(
		() =>
			record.get("date") === "总览" ||
			new Date(`${record.get("date")} 23:59:59`) > new Date(),
	);

	return (
		<div className="flex items-start     " onClick={() => onClick?.({ id })}>
			<div
				className={
					"w-12 h-12 flex shrink-0 justify-center items-center rounded-[14px] bg-cover bg-center "
				}
				onClick={(e) => {
					if (!cover) return;
					e.stopPropagation();
					window.open(`${coverUrl}?imageView2/2/q/90`, "_blank");
				}}
				style={
					coverUrl
						? {
								backgroundImage: `url("${coverUrl}?imageView2/2/w/96/h/96")`,
							}
						: { backgroundColor: config?.bgColor || "#f3f3f3" }
				}
			>
				{!cover && (
					<i
						className={`ic-outline text-gray-800 text-xl  ${
							icon || config?.icon
						}`}
					/>
				)}
			</div>
			<div className="ml-[18px] flex-grow overflow-hidden  ">
				<Type type={type} icon={icon} />

				<b className="text-xl block text-gray-800">{data?.title}</b>
				{(time || money) && (
					<div className="text-gray-500/70 text-sm  flex items-center py-0.5">
						<span className="font-[din] mt-0.5 font-[600]">{time}</span>
						{time && money && <span className="mx-1.5 opacity-50">•</span>}
						{money && money}
					</div>
				)}
				{!!imagesList?.length && (
					<div className="mt-2 flex">
						{imagesList.map((i, index) => (
							<i
								onClick={(e) => {
									e.stopPropagation();
									imageLightBox.show({
										images: imagesList,
										index,
									});
								}}
								style={{
									backgroundImage: `url(${i}?imageView2/2/w/96/h/96)`,
								}}
								className="w-10 h-10  first:rounded-l-md  last:rounded-r-md block mr-[1px] bg-cover bg-center"
								key={i}
							/>
						))}
					</div>
				)}

				{data?.content && isExpand && (
					<div
						className="text-gray-700/80 text-sm mt-1 tiptap-preview break-all"
						// biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
						dangerouslySetInnerHTML={{ __html: data.content }}
					/>
				)}
			</div>
		</div>
	);
}, isEqual);

const Inner = memo((props: IProps) => {
	const record = hooks.useEventsUnsuspended(props.id).data;

	if (!record) return null;

	return <Custom {...props} record={record} />;
}, isEqual);

export default memo((props: IProps) => {
	return (
		<Suspense
		//  fallback={<Skeleton />}
		>
			<Inner {...props} />
		</Suspense>
	);
}, isEqual);
